import React, { Component, PropTypes } from 'react'
import { Link } from 'react-router'
import classnames from 'classnames'

import './FirstTimeBookingConfirmation.scss'
import AliadaProfileCard from 'components/AliadaProfileCard'
import MobileNavBar from 'components/MobileNavBar'
import PromoCodeForm from './components/PromoCodeForm'
import { analytics } from '@src/services/Analytics'
import { formatDate } from 'utils/dates'
import * as paths from 'utils/paths'
import { serviceTypes } from '@src/globals'

class FirstTimeBookingConfirmation extends Component {
  _collectServiceSummarySubmitAnalytics (e) {
    analytics.serviceSummarySubmit({})
  }

  render () {
    const {
      aliada,
      service,
      promoCode,
      goBack
    } = this.props

    const renderPayButton = (aliada) => {
      const linkClass = classnames(
        'btn', 'btn-primary', 'btn-block', 'btn-lg',
        {
          // TODO(Richard Kaufman): Disable button if service information is not complete
          disabled: false
        }
      )

      const paymentStepUrl = paths.bookingPayment(aliada.id)

      return (
        <div className='FirstTimeBookingConfirmation-confirm'>
          <Link
            to={paymentStepUrl}
            className={linkClass}
            onClick={this._collectServiceSummarySubmitAnalytics}
            role='button'>
            Confirmar servicio
          </Link>
        </div>
      )
    }

    const renderServiceInfo = (aliada, service, promoCode) => {
      const weekdaysNameTranslations = {
        'monday': 'Lunes',
        'tuesday': 'Martes',
        'wednesday': 'Miércoles',
        'thursday': 'Jueves',
        'friday': 'Viernes',
        'saturday': 'Sábado',
        'sunday': 'Domingo'
      }

      const datetime = `${service.date} ${service.time}`
      const date = formatDate('D [de] MMMM', datetime)
      const time = formatDate('H a', datetime)
      const dayOfWeek = formatDate('dddd', datetime)

      const serviceWeekdays = service.weekdays.map(weekday => weekdaysNameTranslations[weekday]).join(', ')

      function frequencySummary (serviceTypeId) {
        switch (serviceTypeId) {
          case serviceTypes.ONE_TIME.id:
            return `Una sola vez`

          case serviceTypes.MULTIPLE.id:
            return `Todos los ${serviceWeekdays}`

          case serviceTypes.WEEKLY.id:
          default:
            return `Cada ${dayOfWeek}, misma hora`
        }
      }

      return (
        <div className='FirstTimeBookingConfirmation-serviceInfo'>
          <p>
            Fecha de inicio
            <span>{date}</span>
          </p>
          <p>
            Hora del servicio
            <span>{time}</span>
          </p>
          <p className='FirstTimeBookingConfirmation-serviceInfo-frequency'>
            Frecuencia
            <span>
              {frequencySummary(service.serviceTypeId)}
            </span>
          </p>
          <p>
            Horas solicitadas
            <span>{service.estimatedHours} horas</span>
          </p>
          {
            promoCode.valid && (
              <p className='FirstTimeBookingConfirmation-serviceInfo-discountDescription'>
                {promoCode.promotionName}
              </p>
            )
          }
        </div>
      )
    }

    const userProfileUrl = paths.currentUserProfile()

    return (
      <div className='FirstTimeBookingConfirmation navbar-screen'>
        <MobileNavBar
          leftControl={
            <Link onClick={goBack}>
              <span className='icon-arrow-back' />
            </Link>
          }
          rightControl={
            <Link className='btn btn-default' to={userProfileUrl}>
              Mi perfil
            </Link>
          }
        >
          Confirmación de Servicio
        </MobileNavBar>
        <div className='FirstTimeBookingConfirmation-content navbar-screen-content temporal-width-fix'>
          <div className='navbar-screen-container'>
            <AliadaProfileCard
              aliada={aliada}
              estimatedServiceHours={service.estimatedHours}
              promoCode={promoCode}
              />
            { renderServiceInfo(aliada, service, promoCode) }
            <PromoCodeForm />
            { renderPayButton(aliada) }
          </div>
        </div>
      </div>
    )
  }
}
FirstTimeBookingConfirmation.displayName = 'FirstTimeBookingConfirmation'
FirstTimeBookingConfirmation.propTypes = {
  aliada: PropTypes.object.isRequired,
  service: PropTypes.shape({
    estimatedHours: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    time: PropTypes.string.isRequired,
    weekdays: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  promoCode: PropTypes.object.isRequired,
  goBack: PropTypes.func.isRequired
}

export default FirstTimeBookingConfirmation



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/BookingConfirmation/screens/FirstTimeBookingConfirmation/FirstTimeBookingConfirmation.js